import React, { Component } from 'react';

import { s3CacheUrl } from '../Common/util';

export class SoWQuote extends Component {
  render() {
    return(
      <div className={"collabs-banner-quote sow-fg tile is-5"}>
        {`“My designs for WeftOut feature strong geometric elements and a retro palette reminiscent of a past era which now becomes something of the future.”`}
        <div className={"collabs-banner-byline"}>
          —Stephanie Eventov, Society of Wonderland
        </div>
      </div>
    );
  }
}

export class SoWBio extends Component {
  render() {
    return(
      <div className={"collabs-bio"}>
        <div className={"collabs-divider sow-bg"} />

        <div className={"collabs-section white white tile is-ancestor"}>
          <div className={'collabs-bio-image-container tile is-5'}>
            <img className={"collabs-bio-image"} alt={"Society of Wonderland"} src={s3CacheUrl("https://s3.amazonaws.com/weft-public-assets/images/weft-shop-collab/sow/sow-artist-portrait-1180.jpg", 350)} />
          </div>
          <div className={"collabs-bio-header tile is-5"}>
            <h1>Society of Wonderland</h1>
            <p>Society of Wonderland designer Stephanie Eventov met Weft’s challenge to create a textile collection with WeftOut, our brand new customizable outdoor fabric.</p>
          </div>
        </div>

        <div className={"collabs-section grey"}>
          <div className={"bio-content"}>
            <p>Vibrant color and bold scale define Society of Wonderland’s stylish ensemble of patio perfect patterns. While the collaboration of WeftOut material and SoW design was first intended for the outdoors, styles from the collection are a welcome warm-up in any interior space.</p>

            <p>Known for putting a twist on styles from previous decades, Eventov says her “designs for WeftOut feature strong geometric elements and a retro palette reminiscent of a past era which now becomes something of the future.”
              The new WeftOut quality is similarly “something of the future,” as a first of its kind customizable weather resistant fabric.
              Completely water repellent and UV resistant like other outdoor fabrics on the market, WeftOut’s super power lies in the potential for unlimited pattern possibilities.
              WeftOut users can take Society of Wonderland’s WeftOut collection as a starting point and adjust the colors and scale to match their outdoor settings, or create their own unique patterns completely from scratch (as with all Weft qualities). </p>

              <p>For the launch of WeftOut, Society of Wonderland and Weft also partnered with upholstery studio, Stitchroom to produce custom cushions.
                Stitchroom is a like-minded interior design service of the moment, making everything to order in about two weeks. If you’d like your Weft fabric upholstered on a Stitchroom object, follow the link in Weft Create 3D to learn more about their upholstery options.
                Your Weft fabric can be shipped directly to Stitchroom for ultimate custom decor!</p>

              <p><i>Learn more at <a target="_blank" rel="noopener noreferrer" href="https://www.societyofwonderland.com/">societyofwonderland.com</a> and <a target="_blank" rel="noopener noreferrer" href="https://www.stitchroom.com/">stitchroom.com</a></i></p>

          </div>
        </div>
      </div>
    );
  }
}
